<ng-container *ngIf="groupData && groupData.length > 0; else zeroState">
  <div
    [style.position]="'relative'"
    [style.overflow-x]="'auto'"
    (clientSize)="_.svgSize($event)"
  >
    <svg
      #graph
      xmlns="http://www.w3.org/2000/svg"
      [style.width]="_.width.toString() + 'px'"
      (mouseleave)="_.onLeave()"
      (mousemove)="_.setYHoverable($event)"
    >
      <g id="container">
        <g id="header"></g>
        <g id="chartcontainer">
          <g id="grid"></g>
          <g id="bars"></g>
          <g id="xaxis"></g>
          <g id="yaxis"></g>
        </g>
      </g>
    </svg>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
<ng-template #zeroState>
  <div class="zero-state">{{ emptyStateMessage }}</div>
</ng-template>

<ng-container *ngIf="_.toolTipVisible">
  <deprecated-callout
    *deprecated-callout
    [isModal]="false"
    [anchor]="_.calloutAnchor"
    style="pointer-events: none"
    [preferredPosition]="AnchoredPosition.CENTER_RIGHT"
    fallbackDirection="cw"
  >
    <div class="hover">
      <p
        *ngFor="let data of _.currentHoverable.data; let i = index"
        class="rv-stat-small"
        class="labels"
      >
        <ng-container *ngIf="data === null"> No data </ng-container>
        <ng-container *ngIf="data !== null">
          <span class="symbol"></span>
          <span [class.rv-bold]="data.important"
            >{{ data.label }}: {{ data.value | rivDollars }}</span
          >
        </ng-container>
      </p>
    </div>
  </deprecated-callout>
</ng-container>

<ng-container *ngIf="_.labelHoverName != ''">
  <deprecated-callout
    *deprecated-callout
    [isModal]="false"
    [anchor]="_.calloutAnchor"
    style="pointer-events: none"
    [preferredPosition]="AnchoredPosition.CENTER_RIGHT"
    [calloutHeight]="50"
    [scrollable]="false"
    fallbackDirection="cw"
    ><span class="label-hover">{{ _.labelHoverName }}</span></deprecated-callout
  >
</ng-container>
